import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import FormField from "./FormField";
import { useFormikContext } from "formik";

const StepKeyContacts = ({ fields }) => {
  const { errors, touched } = useFormikContext();

  const renderSection = (title, fieldGroup) => (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.5 }}>
        <Typography variant="h2" sx={{ fontWeight: 600, color: "#242424" }}>
          {title}
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {fieldGroup.map((fieldName) => (
          <Grid item xs={12} key={fieldName}>
            <FormField
              {...fields[fieldName]}
              error={errors[fieldName]}
              touched={touched[fieldName]}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );

  return (
    <Box sx={{ mt: 2, width: "100%", maxWidth: "800px" }}>
      {renderSection("Business Contact", [
        "business_contact_name",
        "business_contact_email",
        "business_contact_phone",
      ])}

      {renderSection("Insurance Contact", [
        "insurance_contact_name",
        "insurance_contact_email",
        "insurance_contact_phone",
      ])}

      {renderSection("Accounting Contact", [
        "accounting_contact_name",
        "accounting_contact_email",
        "accounting_contact_phone",
      ])}
    </Box>
  );
};

export default StepKeyContacts;
